export default "__VITE_ASSET__9a6e26ef__"